module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/mstile-310x310-decdaf74d0c332d53e6f106f0cdaeec1.png";